import { Box,Tooltip,IconButton,Spacer,AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    useDisclosure,
    Button,InputGroup,InputLeftElement,Input
     } from "@chakra-ui/react";
import { useRef } from "react";
import { RiFileExcel2Fill } from "react-icons/ri";
import {  MdListAlt } from "react-icons/md";
import { DeleteIcon,SearchIcon } from "@chakra-ui/icons";

export default function PopisGovedaDetailTableHeader({onGetExcelReport,isGeneratingReport=false,onFilterChange,isCreatingSpecifikacija=false,isDeleting=false,onCreateSpecification,readonly,specopis="",onDelete}) {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const cancelRef = useRef()



    const getSearchBox=()=>{
      return (
          <>
              <InputGroup size={'xs'} w={'30rem'} alignContent={'center'} >
                <InputLeftElement h={'full'} pointerEvents={'none'} children={<SearchIcon/>}></InputLeftElement>
                <Input focusBorderColor='grunt2.400' onChange={onFilterChange} variant={'outline'} placeholder={'*=više znakova/_ =jedan znak'} w={'1000%'}></Input>
              </InputGroup>
              
          </>
      )
  }


const handleDelete=()=>{
    onClose();
    onDelete();
}

const getDeleteDialog=()=>{
    return (
        <>
            <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Brisanje popisa
            </AlertDialogHeader>

            <AlertDialogBody>
              Jeste li sigurni da želite obrisati popis goveda?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose} colorScheme="grunt2" variant={'outline'}>
                Odustani
              </Button>
              <Button colorScheme='red' variant={'outline'} onClick={handleDelete} ml={3}>
                Obriši
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
        </>
    )
}

return (
    <Box display={'flex'} flexDir={'row'} mb={'0.5rem'} ml={'0.5 rem'} mr={'0.5rem'}  >
        {getSearchBox()}
        <Tooltip label={'Izvezi u Excel'}>
            <IconButton isLoading={isGeneratingReport} ml={'1rem'} onClick={onGetExcelReport}  aria-label='Ispis' variant={'outline'} colorScheme={'grunt2'} icon={<RiFileExcel2Fill/>} size={'xs'}/>
        </Tooltip>
        <Spacer/>
       
        {specopis}
       
          <Tooltip label={'Kreiraj specifikaciju'} placement={'left'}>
              <IconButton isDisabled={readonly} isLoading={isCreatingSpecifikacija} onClick={onCreateSpecification} mr={'0.5rem'} ml={'0.5rem'}  key={'prntrgg'} variant={'outline'} colorScheme={'black'} aria-label="KreirajSpec" icon={<MdListAlt/>} size={'xs'}/>
          </Tooltip>
          <Tooltip label={'Obriši popis'} placement={'left'}>
            <IconButton isDisabled={readonly} isLoading={isDeleting} onClick={onOpen} mr={'0.5rem'} ml={'0.5rem'}  key={'delpop'} variant={'outline'} colorScheme={'red'} aria-label="KreirajSpec" icon={<DeleteIcon/>} size={'xs'}/>
          </Tooltip>
        
        
        
        {getDeleteDialog()}
    </Box>
)

}